<template>
  <div class="linktool">
    <div class="bread-crumb">
      Link Tool
    </div>
    <div class="content">
      <a-tabs
        v-model:activeKey="activeKey"
        @change="onTabChange"
      >
        <a-tab-pane
          key="1"
          tab="For Influencer"
        >
          <a-form
            :model="formState"
            name="linkform"
            :label-col="{ span: 3, offset: 0}"
            :wrapper-col="{ span: 9 }"
            @finish="onFinish"
          >
            <a-form-item
              label="Original Link"
              name="originalUrl" 
              :rules="[
                { required: true, message: '请输入URL地址', trigger: 'change',},
                { pattern: urlPattern, message: '请输入正确的URL地址格式', trigger: 'change', }
              ]"
            >
              <a-textarea
                v-model:value="formState.originalUrl"
                rows="2"
                style="max-width: none; width: 600px;"
                placeholder="Please enter advertiser‘s url"
              />
            </a-form-item>
            <a-form-item
              label="influencer"
              name="influencerId" 
              :rules="{ required: true, message: '请输入Influencer', trigger: 'change', }"
            >
              <a-select
                v-model:value="formState.influencerId"
                show-search
                allow-clear
                label-in-value
                placeholder="Please select"
                list-height="340"
                :filter-option="false"
                :not-found-content="kol.fetching ? undefined : null"
                :options="kol.data"
                @clear="clearKol"
                @search="searchKolWhiteList"
              >
                <template
                  v-if="kol.fetching"
                  #notFoundContent
                >
                  <a-spin size="small" />
                </template>
              </a-select>
            </a-form-item>
            <a-form-item
              :wrapper-col="{ offset: 3, span: 16 }"
            >
              <a-button
                type="primary"
                style="width: 200px;"
                html-type="submit"
                :loading="loading"
              >
                Convert
              </a-button>
            </a-form-item>
          </a-form>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          tab="For InRewards"
          force-render
        >
          <a-form
            :model="formState"
            name="linkform"
            :label-col="{ span: 3, offset: 0}"
            :wrapper-col="{ span: 9 }"
            @finish="onFinish"
          >
            <a-form-item
              label="Original Link"
              name="originalUrl"
              :rules="[
                { required: true, message: '请输入URL地址' },
                { pattern: urlPattern, message: '请输入正确的URL地址' }
              ]"
            >
              <a-textarea
                v-model:value="formState.originalUrl"
                rows="2"
                style="max-width: none; width: 600px;"
                placeholder="Please enter advertiser‘s url"
              />
            </a-form-item>
            <a-form-item
              label="IR Campaign"
              name="campaign"
            >
              <a-input
                v-model:value="formState.campaign"
                placeholder="Used to identify different positions"
              />
            </a-form-item>
            <a-form-item
              :wrapper-col="{ offset: 3, span: 16 }"
            >
              <a-button
                type="primary"
                style="width: 200px;"
                html-type="submit"
                :loading="loading"
              >
                Convert
              </a-button>
            </a-form-item>
          </a-form>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div
      v-if="platformNames.length > 0"
      class="content"
      style="margin-top: 20px;"
    >
      <a-form
        name="backform"
        :label-col="{ span: 3, offset: 0}"
        :wrapper-col="{ span: 9 }"
        style="margin-top: 20px;"
      >
        <a-form-item
          label="Social Plaform"
          :wrapper-col="{ span: 16 }"
        >
          <a-space
            :size="[0, 8]"
            wrap
          >
            <a-checkable-tag
              v-for="(tag, index) in platformNames"
              :key="tag"
              v-model:checked="(selectTags[index])"
              class="cus-tag"
              @change="checked => handleChange(tag, checked)"
            >
              {{ tag }}
            </a-checkable-tag>
          </a-space>
        </a-form-item>
        <a-form-item label="Coverted Link">
          <a-input v-model:value="shortLinkUrl" />
        </a-form-item>
        <a-form-item
          :wrapper-col="{ offset: 3, span: 16 }"
        >
          <a-button
            v-copy="shortLinkUrl"
            type="primary"
            style="margin-right: 20px;"
            :loading="loading"
          >
            Copy Link
          </a-button>
          <a-button
            :loading="loading"
            :href="shortLinkUrl"
            target="_blank"
          >
            Test
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import { debounce } from 'lodash-es'
import { advertiser } from '../server/index'
import { message } from 'ant-design-vue'

const activeKey = ref('1');
// KOL白名单
const kol = reactive({
  data: [],
  fetching: false,
})
const formState = reactive({
    originalUrl : '',
    influencerId: undefined,
    campaign: ''
})

const urlPattern = new RegExp(
  '^(https?:\\/\\/)' +           // 必须以 http:// 或 https:// 开头
  '([\\w.-]+)' +                 // 域名部分，例如 www.example 或 localhost
  '(\\.[a-zA-Z]{2,6})?' +        // 可选的顶级域名部分，如 .com/.net/.org
  '(\\/.*)?$'                    // 可选的路径部分
);

const loading = ref(false);

const platformNames = ref([]);

const shortLinkUrl = ref('');

let shortLinks = [];

const selectTags = ref([]);

watch(platformNames, () => {
    selectTags.value = platformNames.value.map(() => {
        return false;
    })
    if (platformNames.value.length > 0 ) {
        handleChange(platformNames.value[0], true);
    }
});

const init = () => {
    searchKolWhiteList()
}

const onTabChange = () => {
    shortLinkUrl.value = '';
    shortLinks = [];
    selectTags.value = [];
    platformNames.value = [];
    formState.originalUrl = '';
    formState.campaign = '';
    formState.influencerId = undefined;
}

const handleChange = (tag,checked) => {
    selectTags.value = platformNames.value.map(item => {
            return item === tag;
    })
    if (checked) {
        shortLinkUrl.value = shortLinks.filter(item => {
            return item.platformName === tag;
        })[0].shortLinkUrl
    }
}

const onFinish = (v) => {
    console.log(v);
    loading.value = true;
    if (activeKey.value === '1') {
        advertiser.convertLink({
            originalUrl: v.originalUrl,
            influencerId: v.influencerId.value
        }).then(res => {
            if (res.success) {
                loading.value = false;
                shortLinks = res.data.shortLinks;
                platformNames.value = res.data.shortLinks.map(item => {return item.platformName});
            } else {
                message.error(res.error)
                loading.value = false;
            }
        })
    } else {
        advertiser.convertOfficialLink(v).then(res => {
            if (res.success) {
                loading.value = false;
                shortLinks = res.data.shortLinks;
                platformNames.value = res.data.shortLinks.map(item => {return item.platformName});
            } else {
                message.error(res.error)
                loading.value = false;
            }
        })
    }
}

const searchKolWhiteList = debounce((keyword) => {
  kol.data = []
  kol.fetching = true
  advertiser.getKolWhiteList(keyword, 20).then((res) => {
    kol.fetching = false
    if (res.success) {
      kol.data = res.data.map((item) => {
        return {
          label: item.name + (item.name ? ' | ' : '') + item.email + ' | ' + item.id,
          value: item.id,
        }
      })
    } else {
      message.error('获取KOL白名单失败，请重试')
    }
  });
}, 300);

const clearKol = () => {
    searchKolWhiteList();
};
init();
</script>
<style scoped>
.content {
    padding: 10px 20px;
}
.cus-tag {
    background-color: #eee;
}
.cus-tag.ant-tag-checkable-checked {
    background-color: #1677ff;
}
</style>
<style>
:where(.css-dev-only-do-not-override-17yhhjv).ant-select-dropdown .ant-select-item {
  min-height: 22px;
  padding: 2px 12px;
}
</style>
